import { IkasOrderLineDiscount } from "./discount";
import { IkasOrderLineVariant } from "./variant";
import { IkasOrderLineItemOption } from "./option";
import { IkasBaseModel } from "../../base";

export type IkasOrderLineItem = {
  currencyCode: string | null;
  currencySymbol: string | null;
  discount: IkasOrderLineDiscount | null;
  discountPrice: number | null;
  finalPrice: number | null;
  finalUnitPrice: number | null;
  options: IkasOrderLineItemOption[] | null;
  originalOrderLineItemId: string | null;
  price: number;
  quantity: number;
  status: IkasOrderLineItemStatus;
  statusUpdatedAt: number | null;
  stockLocationId: string | null;
  taxValue: number | null;
  unitPrice: number | null;
  variant: IkasOrderLineVariant;
  orderedAt: number;
} & IkasBaseModel;

export enum IkasOrderLineItemStatus {
  CANCELLED = "CANCELLED",
  CANCEL_REJECTED = "CANCEL_REJECTED",
  CANCEL_REQUESTED = "CANCEL_REQUESTED",
  DELIVERED = "DELIVERED",
  FULFILLED = "FULFILLED",
  REFUNDED = "REFUNDED",
  REFUND_REJECTED = "REFUND_REJECTED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  REFUND_REQUEST_ACCEPTED = "REFUND_REQUEST_ACCEPTED",
  UNFULFILLED = "UNFULFILLED",
}
